import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

export const CommercialTransactionsLawPage = () => {
	return (
		<PageMeta title="特定商取引法" url={generatePath(PATHS.POLICY.COMMERCIAL_TRANSACTIONS_LAW)}>
			<div className="mx-auto max-w-2xl py-20">
				<div className="text-center text-xl font-bold">特定商取引法に基づく表記</div>
				<div className="py-10 text-sm">
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">販売事業者</div>
						<div className="w-3/4">株式会社CHILLNN</div>
					</div>
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">運営責任者</div>
						<div className="w-3/4">永田諒</div>
					</div>
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">お問い合わせ窓口</div>
						<div className="w-3/4">
							info[at]chillnn.com
							<br />※ 電話番号開示を希望される場合はメールでご連絡いただければ遅延なく開示いたします。
						</div>
					</div>
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">本社所在地</div>
						<div className="w-3/4">京都府京都市下京区花屋町通櫛笥西入薬園町174−9</div>
					</div>
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">商品代金以外の必要料金</div>
						<div className="w-3/4">請求書での利用料支払いの場合、銀行振込手数料</div>
					</div>
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">お支払い方法</div>
						<div className="w-3/4">銀行振込、クレジットカード決済</div>
					</div>
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">代金の支払い時期</div>
						<div className="w-3/4">
							【現地決済手数料】
							<br />
							ご宿泊日当日
							<br />
							【サービス利用料金】
							<br />
							初回申し込みから14日以内、次月以降、契約期間終了の7日前
						</div>
					</div>
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">商品の引き渡し時期</div>
						<div className="w-3/4">
							【クレジットカード支払いの場合】
							<br />
							注文後、すぐにご利用可能になります。
							<br />
							【銀行振込の場合】
							<br />
							入金確認後、3営業日以内に利用可能になります。
						</div>
					</div>
					<div className="flex items-center gap-x-2 px-2 py-4">
						<div className="w-1/4">返品・交換不良品・解約について</div>
						<div className="w-3/4">
							商品特性上、返金・キャンセルについてはお受けできません。
							<br />
							解約はいつでもマイページから行うことができます。
							<br />
							次回決済日までに解約をしていただければ、次回以降の請求は発生いたしません。
						</div>
					</div>
				</div>
			</div>
		</PageMeta>
	);
};
